import React from 'react'
import { injectIntl } from 'react-intl'
import Translation from '../../../global/Translation'

class DisplayDiscontinued extends React.Component {
    render() {
        const { discontinued, inSmallBox = false, isSimplified = false, displayInLine = false, ...props } = this.props

        const smallBoxStyles = {
            fontSize: '8px',
            lineHeight: '9px',
            padding: '2px 4px',
            minHeight: '19px',
            letterSpacing: '0.5px'
        }

        const styles = {
            backgroundColor: '#3C898A',
            color: '#FFFFFF',
            fontWeight: '500',
            fontSize: inSmallBox ? smallBoxStyles.fontSize : '10px',
            lineHeight: inSmallBox ? smallBoxStyles.lineHeight : '11px',
            padding: '4px 8px',
            textTransform: 'uppercase',
            zIndex: 1,
            fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
            position: 'relative',
            display: displayInLine ? 'inline' : 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
            minHeight: '21px',
            textAlign: 'left',
            ...props.style
        }

        if (discontinued) {
            return (
                <div className="discontinued-indicator" style={styles}>
                    <Translation id="discontinued" defaultMessage="Discontinued" />
                    {' - '}
                    {this.props.intl.formatMessage({ id: this.props.discontinued + '_SHORT' })}
                </div>
            )
        }

        if (isSimplified) {
            return (
                <div className="discontinued-indicator" style={styles}>
                    <Translation id="discontinued" defaultMessage="Discontinued" />
                </div>
            )
        }

        return null
    }
}
export default injectIntl(DisplayDiscontinued)
